export default __webpack_public_path__ + "static/media/stone_hover.1b053aec.mp3";